module.exports = __webpack_public_path__ + "img/logo.5e4e59bb.svg";